import SearchInput from 'components/SearchInput';
import ListWrapper from 'components/ListWrapper';
import DataTable from 'components/DataTable';
import styles from './Requests.module.scss';
import {DataTableSchemaItem} from 'types';
import useRequests from './useRequests';
import {useState} from 'react';
import Pagination from 'components/Pagination';
import {useRouteMatch} from 'react-router-dom';
import Button from 'components/Button';
import RefillHandler from './RefillHandler';

const MM_SCHEMA: DataTableSchemaItem[] = [
  {dataKey: 'rx_no', header: 'Rx #', sortable: true, index: 0},
  {dataKey: 'customer', header: 'Patient', sortable: true, index: 1},
  {dataKey: 'status', header: 'Status', sortable: true, index: 2},
  {dataKey: 'drug_name', header: 'Drug name', sortable: false, index: 3},
  {dataKey: 'amount_due', header: 'Amount', sortable: false, index: 4},
  {
    dataKey: 'number',
    header: 'Order #',
    sortable: true,
    align: 'center',
    index: 5,
  },
  {
    dataKey: 'refill',
    header: 'Refill',
    align: 'center',
    index: 6,
  },
];

type Props = {
  source: string;
};

function Requests({source}: Props) {
  const {params} = useRouteMatch<{page: string | undefined}>();

  const {
    history,
    data,
    totalPages,
    // dailyCount,
    loading,
    sortBy,
    sortOrder,
    onSort,
    keyWord,
    setKeyWord,
    refillRef,
    refetch,
    pageSize,
    setPageSize,
    count,
    currentPage,
    setCurrentPage,
    handleNavigateRequest,
  } = useRequests({source});

  const [MMTable] = useState(
    MM_SCHEMA.map((item) => ({
      ...item,
      value: item.dataKey,
      label: item.header,
    }))
  );

  return (
    <>
      <div className={styles.top_header}>
        <SearchInput
          className={styles.input}
          value={keyWord}
          onChange={(val) => {
            setKeyWord(val.target.value);
            setCurrentPage(1);
            if (params.page !== '1') {
              history.push('/prescriber/prescriptions');
            }
            sessionStorage.setItem(`searchKey_${source}`, val.target.value);
          }}
          placeholder="Search"
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: 6,
          }}
        >
          <Button
            onClick={() => history.push('/prescriber/prescriptions-create')}
            color="blue"
          >
            Add Prescription
          </Button>
          {/* <Typography variant="h4">
            Today’s Prescriptions:
            {dailyCount}
          </Typography> */}
        </div>
      </div>
      <ListWrapper>
        {/* <ListTabs
          onChange={setStatus}
          isSupportPage={false}
          activeTabValue={status}
          tabs={MMtabs}
        />
        <ListActionsWrapper>
          <div className={styles.row}>
            <Select
              className={'DeliveryPlanner__Filter'}
              placeholder="Location"
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !location ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                Control: ({children, ...props}) => {
                  return (
                    <components.Control {...props}>
                      <img
                        className={styles.locationIcon}
                        src={locationIcon}
                        alt="location_icon"
                      />
                      {children}
                    </components.Control>
                  );
                },
                SingleValue: ({children, ...props}) => {
                  return (
                    <components.SingleValue {...props}>
                      {isArray(props.selectProps.value)
                        ? props.selectProps.value
                            .map((item: {label: string}) => item.label)
                            .join(', ')
                        : ''}
                    </components.SingleValue>
                  );
                },
                IndicatorSeparator: () => null,
              }}
              isSearchable={false}
              onChange={onChangeLocation}
              isClearable
              options={[
                {
                  label: 'Locations',
                  options: locationOptions,
                },
              ]}
              value={location}
            />
            {source === 'micromerchant' && (
              <Select
                className={styles.selectCon}
                isSearchable={false}
                onChange={(val: any) => setOnlyOTC(val)}
                options={[
                  {label: 'OTC', value: 'true'},
                  {label: 'Rx', value: 'false'},
                ]}
                value={onlyOTC}
                placeholder={
                  <span className="select-placeholder-text">OTC/Rx</span>
                }
                isClearable
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !onlyOTC ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  IndicatorSeparator: () => null,
                }}
              />
            )}
            {source === 'micromerchant' && (
              <Select
                className={styles.selectCon}
                isSearchable={false}
                onChange={(val: any) => setPaid(val)}
                options={[
                  {label: 'Paid', value: 'true'},
                  {label: 'Unpaid', value: 'false'},
                ]}
                value={paid}
                placeholder={
                  <span className="select-placeholder-text">Paid/Unpaid</span>
                }
                isClearable
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !paid ? <components.DropdownIndicator {...props} /> : null,
                  IndicatorSeparator: () => null,
                }}
              />
            )}
          </div>
          {source === 'micromerchant' && (
            <div className={styles.preferenceDate}>
              <DateTimePicker
                icon={calendar}
                showTimeSelect={false}
                dateFormat="MM/dd/yy E"
                value={date}
                placeholder="Pr. date"
                customInput={styles.customInput}
                onChange={onChangeData}
              />
              <Select
                className={styles.selectCon}
                isSearchable={false}
                onChange={(val: any) => setPreferenceTime(val)}
                options={[
                  {label: 'Morning', value: 'morning'},
                  {label: 'Afternoon', value: 'afternoon'},
                  {label: 'Evening', value: 'evening'},
                ]}
                value={preferenceTime}
                placeholder={
                  <span className="select-placeholder-text">Pr. time</span>
                }
                isClearable
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !preferenceTime ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  Control: ({children, ...props}) => (
                    <components.Control {...props} className="select-row">
                      <img className={'timer'} src={stat_time} alt="timer" />
                      {children}
                    </components.Control>
                  ),

                  IndicatorSeparator: () => null,
                }}
              />
              <Select
                className={'Table_Select'}
                isSearchable={false}
                onChange={onChangeTab}
                options={[
                  {
                    label: 'Table column',
                    options: MM_SCHEMA.map((item) => ({
                      ...item,
                      value: item.dataKey,
                      label: item.header,
                    })),
                  },
                ]}
                value={MMTable}
                placeholder={
                  <span className="select-placeholder-text">Display</span>
                }
                components={{
                  Input: () => null,
                  DropdownIndicator: (props) =>
                    !preferenceTime ? (
                      <components.DropdownIndicator {...props} />
                    ) : null,
                  SingleValue: ({children, ...props}) => {
                    return (
                      <components.SingleValue {...props}>
                        Display
                      </components.SingleValue>
                    );
                  },
                  IndicatorSeparator: () => null,
                }}
                closeMenuOnSelect={false}
              />
            </div>
          )}
        </ListActionsWrapper> */}
        <DataTable
          schema={MMTable}
          data={data}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleNavigateRequest}
          onSort={onSort}
          loading={loading}
        />
        {!loading && totalPages > 1 && (
          <Pagination
            count={count}
            pageSize={pageSize}
            setPageSize={setPageSize}
            basePath={'/prescriber/prescriptions'}
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
          />
        )}
        <RefillHandler refetch={refetch} ref={refillRef} />
      </ListWrapper>
    </>
  );
}

export default Requests;
